// „Fájl csatolása" gomb: rejtett `<input type="file">` + programozott `.click()` (a natív fájl-dialógus nem
// helyettesíthető komponenssel). A feltöltés logikája a hívóé — tipikusan a közös `useAttachmentUploader`.
import { PaperClipIcon } from '@heroicons/react/24/outline';
import { type RefObject } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function FilePickButton({
  inputRef,
  accept,
  busy,
  label,
  busyLabel,
  onFiles,
  className,
}: {
  inputRef: RefObject<HTMLInputElement>;
  accept: string;
  busy: boolean;
  label: string;
  busyLabel: string;
  onFiles: (files: FileList) => void;
  className?: string;
}): JSX.Element {
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={accept}
        className="hidden"
        onChange={(e) => {
          if (e.target.files) onFiles(e.target.files);
        }}
      />
      <Button
        variant="ghost"
        size="sm"
        className={cn(className)}
        disabled={busy}
        onClick={() => inputRef.current?.click()}
      >
        <PaperClipIcon className="size-4" />
        {busy ? busyLabel : label}
      </Button>
    </>
  );
}
